import React from 'react';
import { observer } from 'mobx-react-lite';
import { BetHistory } from '@pascal/pascal-core';
import './GameHistory.scss';
import './SelectedHistory.scss';
import { SelectedRow } from './selected-row/selectedRow';

export const BetHistoryWr = observer(() => {
  return <BetHistory selectedRow={SelectedRow} />;
});
